import { createSelector } from 'reselect'

const getLocalState = state => state.pages.focus

export const getFocusTitle = createSelector(
	getLocalState,
	focus => focus.title
)
export const getFocusImage = createSelector(
	getLocalState,
	focus => focus.image
)
export const getFocusContent = createSelector(
	getLocalState,
	focus => focus.content
)



// WEBPACK FOOTER //
// ./src/pages/focus/focusSelectors.js